import { useMsal } from '@azure/msal-react';

const useIsAuthenticated = () => {
  const { accounts } = useMsal();
  return accounts.length > 0;
};

export default useIsAuthenticated;
